import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '@reenstudio/app/shared/components/alert-dialog/alert-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class AlertDialogService {
  constructor(private dialog: MatDialog) {}

  create(
    data: AlertDialogData,
    callbackConfirm?: Function,
    callbackCancel?: Function
  ) {
    if (!data.type) {
      data.type = 'default';
    }

    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe({
      next: (value) => {
        if (value && callbackConfirm) {
          callbackConfirm();
        }
        if (!value && callbackCancel) {
          callbackCancel();
        }
      },
    });
  }
}

export type AlertDialogData = {
  title: string;
  message: string;
  confirm?: string;
  cancel?: string;
  type?: 'default' | 'warning';
};
